import "./App.css";
import TMGClaimSystem from "./TMGClaimSystem";

function App() {
  return <TMGClaimSystem />;
}

export default App;
